import { useSelector } from 'react-redux';

import { selectTotalCount, selectFilters, selectSelectedEntitiesCount } from '../../selectors';
import { selectSelectedFolder } from '../../selectors/folders';
import { EEntityType } from '../../types/filters';
import { getTextCount } from '../../utils/favoriteEntity';

interface ITopBarCount {
  count: number;
  text: string;
}

export const useTopBarCount = (): ITopBarCount => {
  const total = useSelector(selectTotalCount);
  const selectedFolder = useSelector(selectSelectedFolder);
  const selectedCount = useSelector(selectSelectedEntitiesCount);
  const { favoriteEntityType } = useSelector(selectFilters);

  if (selectedCount) {
    return {
      count: selectedCount,
      text: `Выбрано ${selectedCount}`,
    };
  }

  let count = total || 0;
  if (selectedFolder && favoriteEntityType !== EEntityType.Newbuilding) {
    count = selectedFolder.offersCount;
  }

  return {
    count: count || 0,
    text: getTextCount(count),
  };
};
